import { getKeyFromDomain } from "./domainMapping";
import { APP_HOST } from "./domainMapping";
import { getCookie, setCookie } from "./trainUtils";

const storeInCookies = ['currentMMTBookingId'];

function storagePolyfill () {
  const _localStorageSetItem = Storage.prototype.setItem;
  const _localStorageGetItem = Storage.prototype.getItem;

  Storage.prototype.getItem = function (key) {
    const value = _localStorageGetItem.apply(this, arguments);
    if (!value && storeInCookies.includes(key)) {
      const cookieValue = getCookie(key);
      return JSON.stringify(cookieValue);
    }
    return value;
  }

  Storage.prototype.setItem = function (key, value) {
    if (storeInCookies.includes(key)) {
      setCookie(key, JSON.parse(value), 1);
    }
    _localStorageSetItem.apply(this, arguments);
  }

  setCookie(APP_HOST, getKeyFromDomain(), 1);
}

export default storagePolyfill;
